import * as THREE from 'three';
import {
	OrbitControls
} from 'three/examples/jsm/controls/OrbitControls.js';

import{
	RectAreaLightHelper
} from 'three/examples/jsm/helpers/RectAreaLightHelper.js';

import {
	EffectComposer
} from 'three/examples/jsm/postprocessing/EffectComposer.js';
import {
	RenderPass
} from 'three/examples/jsm/postprocessing/RenderPass.js';
import {
	UnrealBloomPass
} from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import {
	GUI
} from 'three/examples/jsm/libs/lil-gui.module.min.js';
import {
	TextGeometry
} from 'three/examples/jsm/geometries/TextGeometry.js';
import {
	FontLoader
} from 'three/examples/jsm/loaders/FontLoader.js';
import {
	Line2
} from 'three/examples/jsm/lines/Line2.js';
import {
	LineGeometry
} from 'three/examples/jsm/lines/LineGeometry.js';
import {
	TWEEN
} from 'three/examples/jsm/libs/tween.module.min.js';
import {
	LineMaterial
} from 'three/examples/jsm/lines/LineMaterialSize.js';
import {
	chinaGeo
} from '@/utils/chinas.js';
import {
	chinaBorder
} from '@/utils/chinaBorder.js';
import {
	countriesGeo
} from '@/utils/countries.js';

import Destination from "@/utils/util.js";
import globalData from "@/utils/globalData.js";

let container, meshGroup, scenceMap2, scenceMap;
let camera, controls, scene, renderer, bloomPass;
let textureLoader, composer,rectLight;
let material, borderMatLine, bottomaterial, topmaterial, submaterial,
	overmaterial, wallMap, wallenvMap, evnMaps;
const params = {
	exposure: 0.1,
	bloomStrength: 1.3,
	bloomThreshold: 0.8,
	bloomRadius: 1
};
const clipPlanes = [
	new THREE.Plane( new THREE.Vector3( 0, 0, 1 ), 100),
	new THREE.Plane( new THREE.Vector3( 0, 0, -1 ), 0),
	 // 第一层高，2.6   第二层层高 6.2   第三层层高 10.0
];
const chinaHieght = 2.2;
const objMap=new Map()
const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();
const textGroup = new THREE.Group();
const chooseGroup = new THREE.Group();
const countryMap = new THREE.Group();
const textList = []
let targetMap = {
	camera: [{
			x: 47.010306263175146,
			y: 64,
			z: -20.819019214880825
		},
		{
			x: 59.76185682813787,
			y: 52.668286449032564,
			z: -4.237566340828286
		},
		{
			x: 53.25843608562303,
			y: 59.54251721275094,
			z: -25.998841513453712
		}
	],
	controls: [{
			x: 0.08,
			y: -16,
			z: -21
		},
		{
			x: -0.47244718181226186,
			y: -16.188760381435813,
			z: -19.502628483629408
		},
		{
			x: 0.08,
			y: -16,
			z: -21
		}
	]
}
let mapMax=0
let mapMin=Infinity

export function init(objData) {
	window.objData = objData
	objData.forEach((res)=>{
		objMap.set(res.name,res)
		mapMax = Math.max(mapMax,res.equipmentNum)
		mapMin = Math.min(mapMin,res.equipmentNum)
	})
	container = document.getElementById('container');
	camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 1, 10000);
	scene = new THREE.Scene();
	scene.fog = new THREE.Fog(0x443333, 1, 2000);
	renderer = new THREE.WebGLRenderer({
		antialias: true
	});
	renderer.autoClear = false;
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.gammaInput = true
	renderer.gammaOutput = true
	renderer.localClippingEnabled = true;
	renderer.toneMappingExposure = Math.pow(0.9, 4.0)
	renderer.setPixelRatio(window.devicePixelRatio)
	container.appendChild(renderer.domElement);
	meshGroup = new THREE.Group()
	controls = new OrbitControls(camera, renderer.domElement);
	controls.enableDamping = true

	camera.position.set(targetMap.camera[0].x, targetMap.camera[0].y, targetMap.camera[0].z);
	controls.target.set(targetMap.controls[0].x, targetMap.controls[0].y, targetMap.controls[0].z);
	controls.update();

	textureLoader = new THREE.TextureLoader();
	const lights = new THREE.AmbientLight(0xffffff, 2); // soft white light
	scene.add(lights);


	evnMaps = textureLoader.load('equirectangular.png')
	scenceMap = textureLoader.load('sky.jpg')
	scenceMap2 = textureLoader.load('scenebj.jpg')
	wallMap = textureLoader.load('wall.png')
	wallenvMap = textureLoader.load('123.jpg')
	wallMap.wrapS = wallMap.wrapT = THREE.RepeatWrapping;
	wallMap.repeat.x = wallMap.repeat.y = 90;
	wallMap.mapping = THREE.UVMapping;
	evnMaps.wrapS = evnMaps.wrapT = THREE.RepeatWrapping;
	evnMaps.mapping = THREE.EquirectangularReflectionMapping;
	wallenvMap.mapping = THREE.EquirectangularReflectionMapping;
	scene.background = scenceMap2;


	///渲染器
	const renderScene = new RenderPass(scene, camera);
	bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 1.5, 0.4, 0.85);
	bloomPass.threshold = params.bloomThreshold;
	bloomPass.strength = params.bloomStrength;
	bloomPass.radius = params.bloomRadius;
	bloomPass.renderToScreen = false;
	composer = new EffectComposer(renderer);
	composer.addPass(renderScene);
	composer.addPass(bloomPass);

	// 经纬度转换为坐标值的函数
	const projection = d3.geoMercator().center([104.0, 37.5]).scale(80).translate([0, 0]);
	const cityMaps = new Map()
	chinaGeo.features.forEach(elem => {
		// 定一个省份3D对象
		// 每个的 坐标 数组
		const coordinates = elem.geometry.coordinates;
		if (elem.properties.center) {
			let center = projection(elem.properties.center);
			cityMaps.set(elem.properties.name, {
				center: center,
				name: elem.properties.name,
				value: 5
			})
			const geoTetx = creatText(elem.properties.name, center)
			meshGroup.add(geoTetx)
		}
		// 循环坐标数组
		coordinates.forEach(multiPolygon => {
			multiPolygon.forEach(polygon => {
				const shape = new THREE.Shape();
				const lineMaterial = new THREE.LineBasicMaterial({
					color: 'white'
				});
				const lineGeometry = new THREE.BufferGeometry()
				let arr = []
				for (let i = 0; i < polygon.length; i++) {
					const [x, y] = projection(polygon[i]);
					if (i === 0) {
						shape.moveTo(x, -y);
					}
					shape.lineTo(x, -y);
					arr.push(new THREE.Vector3(x, -y, chinaHieght + 0.01));
				}
				lineGeometry.setFromPoints(arr)
				const extrudeSettings = {
					depth: chinaHieght,
					bevelEnabled: false
				};
				const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)
				let nums=20
				if(objMap.has(elem.properties.name)){
					nums = objMap.get(elem.properties.name).equipmentNum
					nums = Math.max(nums/mapMax * 50,10)
					nums = 20 + parseInt(nums)
				}
				const wallMaterial = new THREE.MeshPhysicalMaterial({
					color: `hsl(202, 100%, ${nums}%)`,//"hsl(203, 100%, 40%)"
					map: wallMap,
					envMap: evnMaps,
					metalness: 0.9,
					roughness: 0.1,
					envMapIntensity: 1,
					transparent: true,
					opacity: nums==20 ? 0.8 : 1.0 ,
					// depthWrite:false
				})
				const material1 = new THREE.MeshPhysicalMaterial({
					color: '#0a3a87',//00a2ff
					map: wallMap,
					metalness: 0.5,
					roughness: 0.1,
					transparent: true,
					opacity: 0.8,
				})
				const mesh = new THREE.Mesh(geometry, [wallMaterial, material1])
				const line = new THREE.Line(lineGeometry, lineMaterial)
				mesh.name = elem.properties.name
				line.name = elem.properties.name
				chooseGroup.add(mesh)
				meshGroup.add(line)
			})

		})
	})
	meshGroup.add(chooseGroup)
	Destination.Destination(objData, meshGroup, 0, cityMaps, chinaHieght)
	meshGroup.rotateX(-Math.PI / 2)
	meshGroup.rotateZ(Math.PI / 2)
	meshGroup.rotation.z -= 0.13
	meshGroup.position.set(0, 0.7, 0)
	countryMap.rotateX(-Math.PI / 2)
	countryMap.rotateZ(Math.PI / 2)
	countryMap.rotation.z -= 0.13
	countryMap.position.set(0, 0.1, 0)
	scene.add(meshGroup, countryMap)

	// countriesGeo.features.forEach(elem => {
	// 	// 定一个省份3D对象
	// 	// 每个的 坐标 数组
	// 	const coordinates = elem.geometry.coordinates;
	// 	// 循环坐标数组
	// 	coordinates.forEach(multiPolygon => {
	// 		if (multiPolygon[0].length > 2) {
	// 			multiPolygon.forEach(polygon => {
	// 				countriesLayer(polygon, elem)
	// 			})
	// 		} else {
	// 			countriesLayer(multiPolygon, elem)
	// 		}
	// 	})
	// })

	function countriesLayer(multiPolygon, elem) {
		const shape = new THREE.Shape();
		const lineMaterial = new THREE.LineBasicMaterial({
			color: '#005a6c'
		});
		const lineGeometry = new THREE.BufferGeometry()
		let arr = []
		for (let i = 0; i < multiPolygon.length; i++) {
			const [x, y] = projection(multiPolygon[i]);
			if (i === 0) {
				shape.moveTo(x, -y);
			}
			shape.lineTo(x, -y);
			arr.push(new THREE.Vector3(x, -y, 0.51));
		}
		lineGeometry.setFromPoints(arr)
		const extrudeSettings = {
			depth: 0.5,
			bevelEnabled: false
		};
		const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)
		const wallMaterial = new THREE.MeshPhysicalMaterial({
			color: '#0077ff',
			map: wallenvMap,
			envMap: evnMaps,
			metalness: 0.9,
			roughness: 0.5,
			transparent: true,
			opacity: 0.6,
		})
		const material1 = new THREE.MeshBasicMaterial({
			color: '#004e98',
		})
		const mesh = new THREE.Mesh(geometry, [wallMaterial, material1])
		const line = new THREE.Line(lineGeometry, lineMaterial)
		mesh.name = elem.properties.name
		line.name = elem.properties.name
		countryMap.add(mesh)
		countryMap.add(line)
	}

	chinaBorder.features[0].geometry.coordinates.forEach((elem, index) => {

		let borderArr = []
		let borderIndex = []
		let redLineArr = []
		let colors = []
		let num = 0
		for (let i = 0; i < elem[0].length; i++) {
			const [x, y] = projection(elem[0][i]);
			borderArr.push(x, -y, chinaHieght + 0.01);
			redLineArr.push(x, -y, 0);
			num++
			colors.push(num, 0, 0);
			if (num >= 1645) num = 0
		}
		const lineGeometry = new LineGeometry();
		lineGeometry.setPositions(borderArr);
		lineGeometry.setColors(colors);
		const matLine = new LineMaterial({
			color: '#aee3ff',
			chooseColor: '#ffff00',
			linewidth: 0.2, // in world units with size attenuation, pixels otherwise
			worldUnits: true,
			uniformsNeedUpdate: true,
		});
		if (index == 0) borderMatLine = matLine
		let lines = new Line2(lineGeometry, matLine);
		//lines.computeLineDistances();
		lines.scale.set(1, 1, 1);
		meshGroup.add(lines);

		const redlineGeometry = new LineGeometry();
		redlineGeometry.setPositions(redLineArr);
		redlineGeometry.setColors(colors);
		const redlineMaterials = new LineMaterial({
			color: '#0059ff',
			linewidth: 0.2, // in world units with size attenuation, pixels otherwise
			worldUnits: true,
		});
		const redLines = new Line2(redlineGeometry, redlineMaterials)
		meshGroup.add(redLines);
	})
	meshGroup.add(textGroup);

	initBox()
	const size = 1000;
	const divisions = 80;
	const gridHelper = new THREE.GridHelper(size, divisions);

	material = new THREE.ShaderMaterial({
		side: THREE.DoubleSide,
		uniforms: {
			time: {
				value: 1.0
			},
			color: {
				value: new THREE.Color('#e6e6e6')
			},
		},
		vertexShader: `
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
						    vPosition = position;
							gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
						
						}
					`,
		fragmentShader: `
						uniform float time;
						uniform vec3 color;
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
							float dist = distance(vPosition, vec3(0.0,0.0,0.0));
							float a =3.0*sin( dist / 70.0 - time) - 2.3 - (dist*1.5/500.0);
							if(dist>500.0 || a<0.0){
								discard;
							}
							gl_FragColor = vec4(color,a*0.15);
						}
					`,
		transparent: true,
	});
	const subfloormap = textureLoader.load('print.png')
	const overfloormap = textureLoader.load('Goidwhite.png')
	const topfloormap = textureLoader.load('dimg.png')
	subfloormap.wrapS = THREE.RepeatWrapping;
	subfloormap.wrapT = THREE.RepeatWrapping;
	topfloormap.wrapS = THREE.RepeatWrapping;
	topfloormap.wrapT = THREE.RepeatWrapping;
	overfloormap.wrapS = THREE.RepeatWrapping;
	overfloormap.wrapT = THREE.RepeatWrapping;
	topmaterial = new THREE.ShaderMaterial({
		blending: THREE.CustomBlending,
		blendEquation: THREE.AddEquation, //default
		blendSrc: THREE.SrcAlphaFactor, //default
		blendDst: THREE.OneMinusSrcAlphaFactor, //default
		side: THREE.DoubleSide,
		transparent: true,
		uniforms: {
			time: {
				value: 1.0
			},
			color: {
				value: new THREE.Color('#0cabd7')
			},
			pointTexture: {
				value: topfloormap
			}
		},
		vertexShader: `  
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
						    vPosition = position;
							vUv = uv*8.0;
							gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
						
						}
					`,
		fragmentShader: `
						uniform float time;
						uniform vec3 color;
						uniform sampler2D pointTexture;
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
							float dist = distance(vPosition, vec3(0.0,0.0,0.0));
							float a = sin( dist / 100.0 - time);
							if(dist>450.0 || a<0.0){
								a=0.35;
							}
							if(dist > 500.0){
								discard;
							}
							vec4 sourceColor = texture2D(pointTexture, vUv);
							a = a * sourceColor.a;
							vec3 colors = color * sourceColor.rgb;
							gl_FragColor = vec4(colors,a*2.0);
						}
					`,
	});

	submaterial = new THREE.ShaderMaterial({
		blending: THREE.CustomBlending,
		blendEquation: THREE.AddEquation, //default
		blendSrc: THREE.SrcAlphaFactor, //default
		blendDst: THREE.OneMinusSrcAlphaFactor, //default
		side: THREE.DoubleSide,
		transparent: true,
		uniforms: {
			time: {
				value: 1.0
			},
			color: {
				value: new THREE.Color('#00ffff')
			},
			pointTexture: {
				value: subfloormap
			}
		},
		vertexShader: `  
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
						    vPosition = position;
							vUv = uv*6.0;
							gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
						
						}
					`,
		fragmentShader: `
						uniform float time;
						uniform vec3 color;
						uniform sampler2D pointTexture;
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
							float dist = distance(vPosition, vec3(0.0,0.0,0.0));
							float a = 2.0*sin( dist / 100.0 - time) - 1.2;
							if(dist>450.0 || a<0.0){
								a=0.25;
							}
							if(dist > 500.0){
								discard;
							}
							vec4 sourceColor = texture2D(pointTexture, vUv);
							a = a * sourceColor.a;
							vec3 colors = color * sourceColor.rgb;
							gl_FragColor = vec4(colors,a);
						}
					`,
	});

	overmaterial = new THREE.ShaderMaterial({
		blending: THREE.CustomBlending,
		blendEquation: THREE.AddEquation, //default
		blendSrc: THREE.SrcAlphaFactor, //default
		blendDst: THREE.OneMinusSrcAlphaFactor, //default
		//side:THREE.DoubleSide,
		transparent: true,
		uniforms: {
			time: {
				value: 1.0
			},
			color: {
				value: new THREE.Color('#a1f6ff')
			},
			pointTexture: {
				value: overfloormap
			}
		},
		vertexShader: `  
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
						    vPosition = position;
							vUv = uv*15.0;
							gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
						
						}
					`,
		fragmentShader: `
						uniform float time;
						uniform vec3 color;
						uniform sampler2D pointTexture;
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
							float dist = distance(vPosition, vec3(0.0,0.0,0.0));
							float a = sin( dist / 20.0 - time) - 0.90;
							if(dist > 500.0){
								discard;
							}
							vec4 sourceColor = texture2D(pointTexture, vUv);
							a = a * sourceColor.a;
							vec3 colors = color * sourceColor.rgb;
							gl_FragColor = vec4(colors,a);
						}
					`,
	});

	bottomaterial = new THREE.ShaderMaterial({
		blending: THREE.CustomBlending,
		blendEquation: THREE.AddEquation, //default
		blendSrc: THREE.SrcAlphaFactor, //default
		blendDst: THREE.OneMinusSrcAlphaFactor, //default
		//side:THREE.DoubleSide,
		transparent: true,
		uniforms: {
			time: {
				value: 2.0
			},
			color: {
				value: new THREE.Color('#a1f6ff')
			},
			pointTexture: {
				value: overfloormap
			}
		},
		vertexShader: `  
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
						    vPosition = position;
							vUv = uv*15.0;
							gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
						
						}
					`,
		fragmentShader: `
						uniform float time;
						uniform vec3 color;
						uniform sampler2D pointTexture;
						varying vec2 vUv;
						varying vec3 vPosition;
						void main()	{
							float dist = distance(vPosition, vec3(0.0,0.0,0.0));
							float a = sin( dist / 30.0 - time) - 0.95;
							if(dist > 500.0){
								discard;
							}
							vec4 sourceColor = texture2D(pointTexture, vUv);
							a = a * sourceColor.a;
							vec3 colors = color * sourceColor.rgb;
							gl_FragColor = vec4(colors,a);
						}
					`,
	});

	const line = new THREE.LineSegments(gridHelper.geometry, material);
	scene.add(line);

	const topGeometry = new THREE.PlaneGeometry(1200, 1200);
	topGeometry.rotateX(-Math.PI / 2)
	topGeometry.translate(0, -1, 0)


	const topMesh = new THREE.Mesh(topGeometry, topmaterial);
	const subMesh = new THREE.Mesh(topGeometry, submaterial);
	const bottomMesh = new THREE.Mesh(topGeometry, bottomaterial);
	const overMesh = new THREE.Mesh(topGeometry, overmaterial);
	scene.add(topMesh, subMesh, overMesh, bottomMesh);
	window.addEventListener('resize', onWindowResize);
	container.addEventListener('click', onPointerDown);
	animate()
}

function onPointerMove(event) {
	// 将鼠标位置归一化为设备坐标。x 和 y 方向的取值范围是 (-1 to +1)
	pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
	pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
}

function initBox() {
	//扫描激光
	const width = 18;
	const height = 3;
	const intensity = 40;
	rectLight = new THREE.RectAreaLight( '#00bbff', intensity,  width, height );
	rectLight.position.set( 10, 3, -100 );
	rectLight.rotation.x = -Math.PI/2
	scene.add( rectLight )
	//  rectLightHelper = new RectAreaLightHelper( rectLight );
	// scene.add( rectLightHelper );
	
	textGroup.rotation.z += 0.13
	textGroup.position.set(55, -3, 0)
	const geometry = new THREE.BoxGeometry(48, 15, 1);
	const material = new THREE.MeshPhysicalMaterial({
		color: '#007dca',
		map: wallMap,
		envMap: evnMaps,
		metalness: 0.9,
		roughness: 0.2,
		envMapIntensity: 1,
		clippingPlanes:clipPlanes
	})
	const cube = new THREE.Mesh(geometry, material);
	cube.position.set(3.6,0,0)
	new FontLoader().load('/chinamap/fonts.json', function(font) {
		for (let i = 0; i < objData.length; i++) {
			let textGeo = new TextGeometry(objData[i].name, {
				font: font,
				size: 3,
				height: 0.1,
			});
			let materials = new THREE.MeshPhysicalMaterial({
				color: '#686868',
				flatShading: true,
				clippingPlanes:clipPlanes
			}); // front 
			let textMesh = new THREE.Mesh(textGeo, materials); 
			textGroup.add(textMesh);
			textMesh.position.set(-18, 1.5, 0.5)
			let message = '类目xx：' + bigNumberTransform(objData[i].equipmentNum)+'个'
			if(objData[i].projectNum){
				message += '，类目xx：'+bigNumberTransform(objData[i].projectNum)+'个'
			}
			let textGeo1 = new TextGeometry(message, {
				font: font,
				size: 1.5,
				height: 0.1,
			});
			let materials1 = new THREE.MeshPhysicalMaterial({
				color: '#686868',
				flatShading: true,
				clippingPlanes:clipPlanes
			}); // front
			let textMesh1 = new THREE.Mesh(textGeo1, materials1);
			textGroup.add(textMesh1);
			textMesh1.position.set(-18, -4, 0.5)
			if (i == 0) {
				textMesh.visible = true
				textMesh1.visible = true
			} else {
				textMesh.visible = false
				textMesh1.visible = false
			}
			textList.push([textMesh, textMesh1])
			document.getElementById("loading").style.display = 'none'
		}
	});
	textGroup.add(cube);
}

function onPointerDown(event) {
	onPointerMove(event)
	spirtRender()
}

function bigNumberTransform(value) {
	value=Number(value)
	let param = {};
	let k = 10000,
		sizes = ['', '万', '亿', '兆', '京'],
		i;
	if (value < k) {
		param.value = value
		param.unit = ''
	} else {
		i = Math.floor(Math.log(value) / Math.log(k));
		param.value = Math.floor(((value / Math.pow(k, i)))*100)/100
		param.unit = sizes[i];
	}
	return param.value+param.unit+'';
}

function spirtRender() {
	// 通过摄像机和鼠标位置更新射线
	raycaster.setFromCamera(pointer, camera);
	// 计算物体和射线的焦点
	const intersects = raycaster.intersectObjects(chooseGroup.children);
	if (intersects[0] && intersects[0].object.name) {
		for (let i = 0; i < objData.length; i++) {
			if (intersects[0].object.name == objData[i].name) globalData.chooseIndex = i;
			lockTime = 0
		}
	}
	//console.log(camera,controls)
}

function onWindowResize() {
	camera.aspect = window.innerWidth / window.innerHeight;
	camera.updateProjectionMatrix();
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.setPixelRatio(window.devicePixelRatio)
}

function animate() {
	requestAnimationFrame(animate);
	TWEEN.update();
	render();
}

let lockTime = 1

function render() {
	material.uniforms.time.value += 0.02
	topmaterial.uniforms.time.value += 0.02
	submaterial.uniforms.time.value += 0.02
	overmaterial.uniforms.time.value += 0.02
	bottomaterial.uniforms.time.value += 0.02

	borderMatLine.chooseTime += 10
	if (borderMatLine.chooseTime > 1645) borderMatLine.chooseTime = 0
	lockTime++
	if (lockTime >= 600) {
		lockTime = 0
		let ins = getRandomNumber(targetMap.camera.length)
		new TWEEN.Tween(camera.position)
			.to(targetMap.camera[ins], 2000)
			.easing(TWEEN.Easing.Exponential.InOut)
			.start();
		new TWEEN.Tween(controls.target)
			.to(targetMap.controls[ins], 2000)
			.easing(TWEEN.Easing.Exponential.InOut)
			.start();
		globalData.chooseIndex = globalData.chooseIndex < objData.length - 1 ? globalData.chooseIndex + 1 : 0
	}
	controls.update();
	composer.render();
}

function getRandomNumber(num) {
	return Math.floor(Math.random() * num);
}
export function textUploadModel() {
	if (textList.length == 0) return
		for (let i = 0; i < textList.length; i++) {
			textList[i][0].visible = false
			textList[i][1].visible = false
		}
		clipPlanes[0].constant=32
		rectLight.position.set(10,3,-32)
		textList[globalData.chooseIndex][0].visible = true
		textList[globalData.chooseIndex][1].visible = true
		new TWEEN.Tween(clipPlanes[0])
			.to({constant:88}, 2000)
			.easing(TWEEN.Easing.Exponential.Out)
			.start()
		new TWEEN.Tween(rectLight.position)
			.to({ x:10,y:3, z:-88}, 2000)
			.easing(TWEEN.Easing.Exponential.Out)
			.start()
}

function creatText(text, center, color = "#ffffff", size = 15) {
	let canvas = document.createElement("canvas");
	const fontSize = size;
	canvas.width = 120;
	canvas.height = fontSize + 10;
	let c = canvas.getContext('2d');
	// 文字
	c.fillStyle = color; //文本填充颜色
	c.font = `${fontSize}px Georgia`;
	c.fillText(text, 0, 20);
	let Texture = new THREE.CanvasTexture(canvas);
	const material = new THREE.SpriteMaterial({
		map: Texture,
		depthWrite: false
	});
	const sprite = new THREE.Sprite(material);
	sprite.scale.set(2.6, 1, 0)
	sprite.position.set(center[0], -center[1], chinaHieght + 0.5)
	sprite.center.set(0.2, 0.5)
	return sprite
}